import { useState } from 'react'
import { invitation } from '../data/invitation.js'
import styles from './Couple.module.css'

export interface CoupleProps {
  src: string | undefined
}

export function Couple({ src }: CoupleProps) {
  const { groom, bride } = invitation.couple
  // 스펙 §4.1은 main.heic를 허용하고, 안드로이드 크롬은 HEIC를 디코딩하지 못한다.
  // src가 truthy라 자리표시자 분기가 절대 돌지 않으므로, 실패를 직접 붙잡아
  // 같은 자리표시자로 물러난다 — 깨진 이미지 아이콘보다 빈 액자가 낫다.
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const usable = src !== undefined && src !== '' && src !== failedSrc

  return (
    <div className={styles.wrap}>
      <div className={styles.photoFrame}>
        {usable ? (
          <img
            className={styles.photo}
            src={src}
            alt="신랑 신부 메인 사진"
            decoding="async"
            onError={() => setFailedSrc(src)}
          />
        ) : (
          <div className={styles.placeholder} />
        )}
      </div>
      <div className={styles.names}>
        <div className={styles.row}>
          <span className={styles.parents}>{groom.parents}</span>
          <span className={styles.relation}>{groom.relation}</span>
          <span className={styles.given}>{groom.name}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.parents}>{bride.parents}</span>
          <span className={styles.relation}>{bride.relation}</span>
          <span className={styles.given}>{bride.name}</span>
        </div>
      </div>
    </div>
  )
}
